import { Typography, TypographyProps } from "@mui/material";
import React from "react";

/**
 * Common component for step description text in product detail sections.
 * Applies consistent font size, weight, and margin.
 */
const StepDescriptionText: React.FC<TypographyProps> = ({ children, ...props }) => (
  <Typography mt={'9px'} width={'90%'} textAlign={'center'} fontSize={14} fontWeight={400} mb={0.5} {...props}>
    {children}
  </Typography>
);

export default StepDescriptionText; 